import type { PlateElementProps } from 'platejs/react';

import { Link } from 'common/components/Link';
import { getSafeLinkUrl } from 'common/components/ContentEditor/utils/editorHelpers';

export const EditorLink = ({
    element,
    children,
    attributes,
}: PlateElementProps) => {
    const { url } = element as { url?: string };

    // Defense-in-depth: url can reach this render path without ever going
    // through LinkDialog's validation (pasted HTML, legacy article content
    // saved before validation existed), so a javascript:/data: href must be
    // stripped here too, not just rejected at the dialog. Relative hrefs are
    // accepted so an internal link held in content keeps working.
    const safeUrl = getSafeLinkUrl(url);

    return (
        <span {...attributes}>
            <Link href={safeUrl} target="_blank" underline="always">
                {children}
            </Link>
        </span>
    );
};
